<div class="login-container d-flex flex-column justify-content-center align-items-center shadow">
  <div class="login-card p-5">
    <!-- Logo -->
    <div class="login-logo mx-auto">
    </div>

    <!-- OIDC Login -->
    <div *ngIf="oidcList.length">

      <ng-container *ngFor="let provider of oidcList">
        <button  class="btn btn-primary oidc-button w-100 my-3"
                type="button"
                (click)="startOidc(provider)"
                tabindex="1">
          <img  [src]="'assets/images/icon_'+provider.toLowerCase()+'.png'"
                class="oidc-icon"
                [alt]="provider + ' icon'"
                onerror="this.style.display='none'">
          LOGIN WITH {{ provider.toUpperCase() }}
        </button>
      </ng-container>

      <!-- OIDC Divider -->
      <div class="divider my-4">
        <span class="divider-text text-muted">or continue with email</span>
      </div>
    </div>

    <!-- Email Login -->
    <form (ngSubmit)="login()" #loginForm="ngForm">
      <div class="mb-5">
        <label for="username" class="login-form-label mb-1">Username:</label>
        <input id="username" name="username" type="text" class="form-control" 
              [(ngModel)]="username" required tabindex="2">
      </div>
      <div>
        <div class="d-flex justify-content-between align-items-center mb-1">
          <label for="password" class="login-form-label">Password:</label>
          <a [href]="forgotPasswordLink" target="_blank" class="login-form-label" tabindex="4">
            Forgot Password?
          </a>
        </div>
        <input id="password" name="password" type="password" class="form-control"
              [(ngModel)]="password" required tabindex="3">
      </div>
      <div class="d-grid">
        <div *ngIf="error_message" class="error-text text-center mb-3">
          <span><strong>Login Failed:</strong> {{ error_message }}</span>
        </div>
        <button type="submit" class="btn btn-primary login-button" tabindex="5">LOG IN</button>
      </div>
    </form>
  </div>
</div>
